export const AG_GRID_LOCALE_FA = {
  // Set Filter
  selectAll: '(انتخاب همه)',
  selectAllSearchResults: '(انتخاب همه نتایج جستجو)',
  searchOoo: 'جستجو...',
  blanks: '(خالی)',
  noMatches: 'نتیجه ای نداشت',

  // Number Filter & Text Filter
  filterOoo: 'فیلتر...',
  equals: 'مساوی',
  notEqual: 'نامساوی',
  blank: 'خالی',
  notBlank: 'خالی نبودن',
  empty: 'انتخاب یکی',

  // Number Filter
  lessThan: 'کوچکتر از',
  greaterThan: 'بزرگتر از',
  lessThanOrEqual: 'کوچکتر مساوی',
  greaterThanOrEqual: 'بزرگتر مساوی',
  inRange: 'در بین رنج',
  inRangeStart: 'از',
  inRangeEnd: 'به',

  // Text Filter
  contains: 'شامل',
  notContains: 'شامل نیست',
  startsWith: 'شروع با',
  endsWith: 'پایان با',

  // Date Filter
  dateFormatOoo: 'yyyy-mm-dd',

  // Filter Conditions
  andCondition: 'و',
  orCondition: 'یا',

  // Filter Buttons
  applyFilter: 'ذخیره',
  resetFilter: 'بازنشانی',
  clearFilter: 'پاک کردن',
  cancelFilter: 'انصراف',

  // Filter Titles
  textFilter: 'فیلتر رشته',
  numberFilter: 'فیلتر عدد',
  dateFilter: 'فیلتر تاریخ',
  setFilter: 'اعمال فیلتر',

  // Side Bar
  columns: 'ستون ها',
  filters: 'فیلتر ها',

  // columns tool panel
  pivotMode: 'حالت محوری',
  groups: 'گروه ستون ها',
  rowGroupColumnsEmptyMessage: 'برای گروه بندی یک فیلد را بکشید',
  values: 'مقادیر',
  valueColumnsEmptyMessage: 'به اینجا بکشید',
  pivots: 'عنوان ستون ها',
  pivotColumnsEmptyMessage: 'برای تنظیم برچسب های ستون، اینجا را بکشید',

  // Header of the Default Group Column
  group: 'گروه ها',

  // Row Drag
  rowDragRows: 'ردیف ها',

  // Other
  loadingOoo: 'در حال بارگزاری ... ',
  noRowsToShow: 'دیتایی وجود ندارد',
  enabled: 'فعال',

  // Menu
  pinColumn: 'سنجاق ستون',
  pinLeft: 'سنجاق چپ',
  pinRight: 'سنجاق راست',
  noPin: 'بدون سنجاق',
  valueAggregation: 'تجمع داده ها',
  autosizeThiscolumn: 'اندازه خودکار این ستون',
  autosizeAllColumns: 'اندازه خودکار تمام ستون ها',
  groupBy: 'گروه بندی با',
  ungroupBy: 'بدون گروه بندی',
  addToValues: 'اضافه کردن ${variable} به مقادیر',
  removeFromValues: 'حذف ${variable} از مقادیر',
  addToLabels: 'اضافه کردن ${variable} به برچسب ها',
  removeFromLabels: 'حذف ${variable} از برچسب ها',
  resetColumns: 'بازنشانی ستون ها',
  expandAll: 'باز کردن همه',
  collapseAll: 'بستن همه',
  copy: 'کپی',
  ctrlC: 'Ctrl+C',
  copyWithHeaders: 'کپی با هدر',
  copyWithHeaderGroups: 'کپی با هدر گروه',
  paste: 'چسباندن',
  ctrlV: 'Ctrl+V',
  export: 'خروجی گرفتن',
  csvExport: 'خروجی CSV',
  excelExport: 'خروجی Excel',

  // Enterprise Menu Aggregation and Status Bar
  sum: 'Sum',
  min: 'Min',
  max: 'Max',
  none: 'None',
  count: 'Count',
  avg: 'Average',
  filteredRows: 'فیلتر شده',
  selectedRows: 'انتخاب شده',
  totalRows: 'تعداد ستون ها',
  totalAndFilteredRows: 'Rows',
  more: 'بیشتر',
  to: 'به',
  of: 'از',
  page: 'صفحه',
  nextPage: 'صفحه بعد',
  lastPage: 'صفحه آخر',
  firstPage: 'صفحه اول',
  previousPage: 'صفحه قبل',

  // Pivoting
  pivotColumnGroupTotals: 'مجموع',

  // Enterprise Menu (Charts)
  pivotChartAndPivotMode: 'Pivot Chart & Pivot Mode',
  pivotChart: 'Pivot Chart',
  chartRange: 'Chart Range',

  columnChart: 'Column',
  groupedColumn: 'Grouped',
  stackedColumn: 'Stacked',
  normalizedColumn: '100% Stacked',

  barChart: 'Bar',
  groupedBar: 'Grouped',
  stackedBar: 'Stacked',
  normalizedBar: '100% Stacked',

  pieChart: 'Pie',
  pie: 'Pie',
  doughnut: 'Doughnut',

  line: 'Line',

  xyChart: 'X Y (Scatter)',
  scatter: 'Scatter',
  bubble: 'Bubble',

  areaChart: 'Area',
  area: 'Area',
  stackedArea: 'Stacked',
  normalizedArea: '100% Stacked',

  histogramChart: 'Histogram',

  combinationChart: 'Combination',
  columnLineCombo: 'Column & Line',
  AreaColumnCombo: 'Area & Column',

  // Charts
  pivotChartTitle: 'Pivot Chart',
  rangeChartTitle: 'Range Chart',
  settings: 'Settings',
  data: 'Data',
  format: 'Format',
  categories: 'Categories',
  defaultCategory: '(None)',
  series: 'Series',
  xyValues: 'X Y Values',
  paired: 'Paired Mode',
  axis: 'Axis',
  navigator: 'Navigator',
  color: 'Color',
  thickness: 'Thickness',
  xType: 'X Type',
  automatic: 'Automatic',
  category: 'Category',
  number: 'Number',
  time: 'Time',
  xRotation: 'X Rotation',
  yRotation: 'Y Rotation',
  ticks: 'Ticks',
  width: 'Width',
  height: 'Height',
  length: 'Length',
  padding: 'Padding',
  spacing: 'Spacing',
  chart: 'Chart',
  title: 'Title',
  titlePlaceholder: 'Chart title - double click to edit',
  background: 'Background',
  font: 'Font',
  top: 'Top',
  right: 'Right',
  bottom: 'Bottom',
  left: 'Left',
  labels: 'Labels',
  size: 'Size',
  minSize: 'Minimum Size',
  maxSize: 'Maximum Size',
  legend: 'Legend',
  position: 'Position',
  markerSize: 'Marker Size',
  markerStroke: 'Marker Stroke',
  markerPadding: 'Marker Padding',
  itemSpacing: 'Item Spacing',
  itemPaddingX: 'Item Padding X',
  itemPaddingY: 'Item Padding Y',
  layoutHorizontalSpacing: 'Horizontal Spacing',
  layoutVerticalSpacing: 'Vertical Spacing',
  strokeWidth: 'Stroke Width',
  offset: 'Offset',
  offsets: 'Offsets',
  tooltips: 'Tooltips',
  callout: 'Callout',
  markers: 'Markers',
  shadow: 'Shadow',
  blur: 'Blur',
  xOffset: 'X Offset',
  yOffset: 'Y Offset',
  lineWidth: 'Line Width',
  normal: 'Normal',
  bold: 'Bold',
  italic: 'Italic',
  boldItalic: 'Bold Italic',
  predefined: 'Predefined',
  fillOpacity: 'Fill Opacity',
  strokeOpacity: 'Line Opacity',
  histogramBinCount: 'Bin count',
  columnGroup: 'Column',
  barGroup: 'Bar',
  pieGroup: 'Pie',
  lineGroup: 'Line',
  scatterGroup: 'X Y (Scatter)',
  areaGroup: 'Area',
  histogramGroup: 'Histogram',
  combinationGroup: 'Combination',
  groupedColumnTooltip: 'Grouped',
  stackedColumnTooltip: 'Stacked',
  normalizedColumnTooltip: '100% Stacked',
  groupedBarTooltip: 'Grouped',
  stackedBarTooltip: 'Stacked',
  normalizedBarTooltip: '100% Stacked',
  pieTooltip: 'Pie',
  doughnutTooltip: 'Doughnut',
  lineTooltip: 'Line',
  groupedAreaTooltip: 'Area',
  stackedAreaTooltip: 'Stacked',
  normalizedAreaTooltip: '100% Stacked',
  scatterTooltip: 'Scatter',
  bubbleTooltip: 'Bubble',
  histogramTooltip: 'Histogram',
  columnLineComboTooltip: 'Column & Line',
  areaColumnComboTooltip: 'Area & Column',
  customComboTooltip: 'Custom Combination',
  noDataToChart: 'No data available to be charted.',
  pivotChartRequiresPivotMode: 'Pivot Chart requires Pivot Mode enabled.',
  chartSettingsToolbarTooltip: 'Menu',
  chartLinkToolbarTooltip: 'Linked to Grid',
  chartUnlinkToolbarTooltip: 'Unlinked from Grid',
  chartDownloadToolbarTooltip: 'Download Chart',
  seriesChartType: 'Series Chart Type',
  seriesType: 'Series Type',
  secondaryAxis: 'Secondary Axis',

  // ARIA
  ariaChecked: 'checked',
  ariaColumn: 'Column',
  ariaColumnGroup: 'Column Group',
  ariaColumnList: 'Column List',
  ariaColumnSelectAll: 'Toggle Select All Columns',
  ariaDateFilterInput: 'Date Filter Input',
  ariaDefaultListName: 'List',
  ariaFilterColumnsInput: 'Filter Columns Input',
  ariaFilterFromValue: 'Filter from value',
  ariaFilterInput: 'Filter Input',
  ariaFilterList: 'Filter List',
  ariaFilterToValue: 'Filter to value',
  ariaFilterValue: 'Filter Value',
  ariaFilteringOperator: 'Filtering Operator',
  ariaHidden: 'hidden',
  ariaIndeterminate: 'indeterminate',
  ariaInputEditor: 'Input Editor',
  ariaMenuColumn: 'Press CTRL ENTER to open column menu.',
  ariaRowDeselect: 'Press SPACE to deselect this row',
  ariaRowSelectAll: 'Press Space to toggle all rows selection',
  ariaRowToggleSelection: 'Press Space to toggle row selection',
  ariaRowSelect: 'Press SPACE to select this row',
  ariaSearch: 'Search',
  ariaSortableColumn: 'Press ENTER to sort',
  ariaToggleVisibility: 'Press SPACE to toggle visibility',
  ariaUnchecked: 'unchecked',
  ariaVisible: 'visible',
  ariaSearchFilterValues: 'Search filter values',

  // ARIA Labels for Drop Zones

  ariaRowGroupDropZonePanelLabel: 'Row Groups',
  ariaValuesDropZonePanelLabel: 'Values',
  ariaPivotDropZonePanelLabel: 'Column Labels',
  ariaDropZoneColumnComponentDescription: 'Press DELETE to remove',
  ariaDropZoneColumnValueItemDescription: 'Press ENTER to change the aggregation type',

  // ARIA Labels for Dialogs
  ariaLabelColumnMenu: 'Column Menu',
  ariaLabelCellEditor: 'Cell Editor',
  ariaLabelDialog: 'Dialog',
  ariaLabelSelectField: 'Select Field',
  ariaLabelTooltip: 'Tooltip',
  ariaLabelContextMenu: 'Context Menu',
  ariaLabelSubMenu: 'SubMenu',
  ariaLabelAggregationFunction: 'Aggregation Function',

  // Number Format (Status Bar, Pagination Panel)
  thousandSeparator: ',',
  decimalSeparator: '.',
};
